module.exports = __webpack_public_path__ + "media/images/icons/filled/message-89150e13b7661c1e7b94b962a73bac27.svg";